<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-4 m-lg-3">
          <div class="card-body">
            <div class="row align-items-center rental-payment">
              <div class="col mt-4 d-none d-sm-block">
                <h4 class="ms-2">View {{ this.userRole }} Details</h4>
              </div>
              <div class="col mt-4 d-block d-sm-none">
                <h4 class="ms-2">View {{ this.userRole }}</h4>
              </div>
              <div
                class="col-12 col-sm-6 col-md-4 d-flex justify-content-end me-2 add-btn"
              >
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary me-2 d-none d-sm-block new-btn "
                  @click="BackToUserDetails()"
                >
                  Back To {{ this.userRole }} List
                </llp-button>
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary me-2 d-block d-sm-none new-btn"
                  @click="BackToUserDetails()"
                >
                  Go Back
                </llp-button>
              </div>
            </div>

            <div class="row p-1">
               <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="firstName" :aria-label="FirstName">
                  First Name:
                </llp-label>
                <llp-input
                  id="firstName"
                  v-model:modelValue="adminData.firstName"
                 disabled
                ></llp-input>
               </div>
           
                <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="firstName" :aria-label="FirstName">
                  Last Name:
                </llp-label>
                <llp-input
                  id="firstName"
                  v-model:modelValue="adminData.lastName"
                 disabled
                ></llp-input>
               </div>
                <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="firstName" :aria-label="FirstName">
                  Mobile:
                </llp-label>
                <llp-input
                  id="firstName"
                  v-model:modelValue="adminData.mobile"
                 disabled
                ></llp-input>
               </div>

             
            </div>

            <div class="row p-1">
                <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="firstName" :aria-label="FirstName">
                  Address:
                </llp-label>
                <llp-input
                  id="firstName"
                  v-model:modelValue="adminData.address"
                 disabled
                ></llp-input>
               </div>
             
               <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="firstName" :aria-label="FirstName">
                  City:
                </llp-label>
                <llp-input
                  id="firstName"
                  v-model:modelValue="adminData.city"
                 disabled
                ></llp-input>
               </div>
            <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="firstName" :aria-label="FirstName">
                  State:
                </llp-label>
                <llp-input
                  id="firstName"
                  v-model:modelValue="adminData.state"
                 disabled
                ></llp-input>
               </div>
            </div>
            <div class="row p-1">
                <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="firstName" :aria-label="FirstName">
                  Pincode:
                </llp-label>
                <llp-input
                  id="firstName"
                  v-model:modelValue="adminData.pinCode"
                 disabled
                ></llp-input>
               </div>
              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="firstName" :aria-label="FirstName">
                  Email:
                </llp-label>
                <llp-input
                  id="firstName"
                  v-model:modelValue="adminData.email"
                 disabled
                ></llp-input>
               </div>
               <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="firstName" :aria-label="FirstName">
                  Status:
                </llp-label>
                <llp-input
                  id="firstName"
                  v-model:modelValue="adminData.status"
                 disabled
                ></llp-input>
               </div>

            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import NetworkService from "@/services/network.service";
export default {
  setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      loginUserId: localStorage.getItem("User_id"),
      addUserRole: "",
      id: "",
      adminData: {
        firstName: "",
        lastName: "",
        mobile: "",
        address: "",
        city: "",
        email: "",
        state: "",
        pinCode: "",
        initialWallet: "",
        status: "",
        panNumber: "",
        aadhaarNumber: "",
        businessName: "",
        contactNumber: "",
        businessAddress: "",
        gst: "yes",
        userRole: "",
      },
    };
  },
  watch: {
    "$route.params": {
      handler(newParams) {
        this.role = newParams.role;
        this.id = newParams.id;
        this.setRoleIdAndFetch();
        this.addUserRole = newParams.role;
        this.userRole = this.role.charAt(0).toUpperCase() + this.role.slice(1);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.setRoleIdAndFetch();
    this.fetchUserDetails();
  },

  methods: {
    setRoleIdAndFetch() {
      if (this.role == "admin") {
        this.roleId = 2;
      } else if (this.role == "distributor") {
        this.roleId = 3;
      } else if (this.role == "retailer") {
        this.roleId = 4;
      } else {
        this.roleId = "";
      }
    },
    BackToUserDetails() {
      this.$router.back();
    },
    async fetchUserDetails() {
      try {
        const response = await NetworkService.get(
          `get-user-details/${this.id}`
        );
        this.userDetails = response;
        this.adminData.firstName =
        this.userDetails.user.user_details.first_name;
        this.adminData.lastName = this.userDetails.user.user_details.last_name;
        this.adminData.mobile = this.userDetails.user.mobile;
        this.adminData.address = this.userDetails.user.user_details.address;
        this.adminData.city = this.userDetails.user.user_details.city;
        this.adminData.state = this.userDetails.user.user_details.state;
        this.adminData.pinCode = this.userDetails.user.user_details.pincode;
        this.adminData.status = this.userDetails.user.status == '1' ? 'Active' : 'Inactive';
        this.adminData.email = this.userDetails.user.email;
      } catch (error) {
        this.$refs.toast.show("Unable to fetch the user details.", "error");
      }
    },
  },
};
</script>